"use strict";
//var $ = require('jquery');

/**
* The purpose of this function is to either hide the graph and show the loading
* spinner or to hide the loading spinner and show the graph
* no parameters or returns
*/

function loading()
{
    return;
    //$("#progress").toggle();
    //$("#graph").toggle();
}

/**
* The point of this method is to disable the custom area of the meteorogram
* header
*
* no params
* no returns
*/

function disable()
{
	//disable custom rows
	$('#Start-date-picker').prop("disabled", true);
	$('#Start-time-picker').prop("disabled", true);
	$('#End-date-picker').prop("disabled", true);
	$('#End-time-picker').prop("disabled", true);
	$('#interval').prop("disabled", true);
	$('#Plot').prop("disabled", true);
}

/**
* The purpose of this method is to enable the custom area of the meteorogram
* header
*
* no params
* no returns
*/

function enable()
{
	//enable custom rows
	$('#Start-date-picker').prop("disabled", false);
	$('#Start-time-picker').prop("disabled", false);
	$('#End-date-picker').prop("disabled", false);
	$('#End-time-picker').prop("disabled", false);
	$('#interval').prop("disabled", false);
}

/**
* The purpose of this function is to take a date string and a time string and turn that
* into a date JS object
*
* @param dateString - "MM/DD/YYYY"
* @param timeString - "HH-MM-SS"
* @return date object
*/

function getDate(dateString, timeString)
{
	//get date string
	var year = parseInt(dateString.substring(6,10));
	var month = parseInt(dateString.substring(0,3));
	var day = parseInt(dateString.substring(3,5));
	var hour = parseInt(timeString.substring(0,2));
	var minute = parseInt(timeString.substring(3,5));
	var seconds = parseInt(timeString.substring(6,8));

    //return date variable
    var date = new Date(year, month, day, hour, minute, seconds);

    return date;
}

/**
* The purpose of this method is to make sure each field is valid and does
* not result in too much or too less data points being plotted
* @param start date - the date the user wants to start at
* @param time user wants to start at
* @param end Date - the date user wants to stop at
* @param end Time - the time the user wants to stop at
* @param interval - how many seconds averaged does the user want
* no returns
*/

/**
* The purpsoe of this method is to enable the plot button
*
* no params
* no returns
*/

function enablePlot()
{
	//enable plot button
	$('#Plot').prop("disabled", false);
}

/**
* The purpose of this method is to disable the plot button
*
* no params
* no returns
*/

function disablePlot()
{
	//disable plot button
	$('#Plot').prop("disabled", true);
}

function checkFields(startDate, endDate, startTime, endTime, interval)
{
	//get user information from selected drop down
	var selected = $('#interval option:selected');

    //give user time to fill out other fields
	if(selected.text() == '--');

	else
	{
		//get information to create a message to the user saying approx how many pts
		//they are plotting
        var start = getDate(startDate, startTime);
        var end = getDate(endDate, endTime);
        var selected = $('#interval option:selected');
        var diff = (end - start)/1000;
        var intervalVal = selected.data("seconds");
        diff = Math.floor(diff/intervalVal);
        var points = diff/interval;

        //if too few points, tell user
        if(diff >= 0 && diff < 60)
        {
        	$('#prompt_user').html('a ' + selected.text() + ' interval would plot about ' + diff.toString() 
        		 + ' data points; that\'s too few - please try again');
			$('#default').attr('selected', 'selected');
			disablePlot();
        }

        //if the user accidentally mixed up start and end dates, politely tell them
        else if(diff < 0)
        {
        	$('#prompt_user').html('The end date is before the start date. Please choose a later end date.');
			$('#default').attr('selected', 'selected');
        }

        //if too many points, tell user
        else if(diff > 1000)
        {
        	$('#prompt_user').html('a ' + selected.text() + ' interval would plot about '
        		+ diff.toString() + ' data points; that\'s too many - please try again');
			$('#default').attr('selected', 'selected');
			disablePlot();
        }

        //else we enable the plot button and tell user how many points they're plotting
        else
        {
        	$('#prompt_user').html('a ' + selected.text() + ' interval would plot about '
        		+ diff.toString() + ' data points.');

			enablePlot();
        }

	}
}

/**
* The purpose of this method is to make sure all the fields and intervals selected are valid
*
* No parameters
* No returns
*/

function checkInterval()
{
	var startDate = $('#Start-date-picker').val();
	var endDate = $('#End-date-picker').val();
	var startTime = $('#Start-time-picker').val();
	var endTime = $('#End-time-picker').val();
	var interval = $('#interval');

	//get user information from selected drop down
	var selected = $('#interval option:selected');

    //check if any fields are not filled out
	if((!startDate || !endDate || !startTime || !endTime) && selected.text() != '--')
	{
		$('#prompt_user').html('Please fill out all other fields before filling out the interval field');
		$('#default').attr('selected', 'selected');
	}

    //check to see if fields are ok
	checkFields(startDate, endDate, startTime, endTime, interval);
}

module.exports.loading = loading;
module.exports.disable = disable;
module.exports.enable = enable;
module.exports.checkInterval = checkInterval;
